/* eslint-disable @typescript-eslint/no-explicit-any */
import { map } from "lodash";

import { useDropdownSourceContext } from "@ryde/redux";
import { NO_VALUE_DISPLAY, RydeUiUnit } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvListCellTransformer = (): {
  getCsvListValue: CsvCellTransformerFn;
} => {
  const { getDropdownLabels } = useDropdownSourceContext();

  const getItems = async (
    value: any,
    dropItemsSource?: RydeUiUnit,
    csvListMapFieldName?: string,
  ): Promise<null | string[]> => {
    if (dropItemsSource) {
      const mappedValue = csvListMapFieldName
        ? map(value, csvListMapFieldName)
        : value;
      const labels = await getDropdownLabels(
        dropItemsSource,
        mappedValue ?? [],
      );
      return labels;
    } else {
      if (Array.isArray(value) && value?.length) {
        const mappedValue = csvListMapFieldName
          ? map(value, csvListMapFieldName)
          : value;
        return mappedValue?.map(String);
      }
    }

    return null;
  };

  const getCsvListValue = async ({
    value,
    formAttributes,
    gridAttributes,
  }: ICsvColumnTransformer): Promise<string> => {
    const { dropItemsSource } = formAttributes || {};
    const { csvListMapFieldName } = gridAttributes || {};

    const allValues = await getItems(
      value,
      dropItemsSource,
      csvListMapFieldName,
    );

    if (Array.isArray(allValues) && allValues?.length) {
      return allValues.join(", ");
    }

    return NO_VALUE_DISPLAY;
  };

  return { getCsvListValue };
};
